<template>
    <div :class="`label-field label-align-${labelPosition}`">
        <label>
            <span :style="labelStyle">{{ label }}</span>
            <KpTooltip v-if="labelTip" :close-delay="labelTipCloseDelay" :content-class="contentClass">
                <template #activator="{ on, attrs }">
                    <i
                        v-bind="attrs"
                        class="ic ic-12 ic-col-light-blue ic-support ml-1"
                        :class="iconClass"
                        @click="$emit('icon-click')"
                        v-on="on"
                    ></i>
                </template>
                <div style="max-width: 350px">{{ labelTip }}</div>
            </KpTooltip>
        </label>

        <slot></slot>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import type { PropType } from 'vue';

export default Vue.extend({
    props: {
        labelStyle: {
            type: [String, Object],
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        labelTip: {
            type: String,
            default: null,
        },
        labelTipCloseDelay: {
            type: [String, Number],
            default: 0,
        },
        labelPosition: {
            type: String as PropType<'top' | 'left'>,
            default: 'top',
        },
        contentClass: {
            type: String,
            default: 'tooltip-default',
        },
        iconClass: {
            type: String,
            default: ''
        }
    },
});
</script>

<style lang="scss" scoped>
.label-field {
    label {
        display: block;
        color: var(--gray-text-color);
        font-size: 0.875rem;
        font-weight: bold;
    }
}
.label-field.label-align-top {
    display: flex;
    flex-direction: column;
    label {
        margin-bottom: 2px;
    }
}
.label-field.label-align-left {
    display: flex;
    flex-direction: row;
    align-items: center;
    label {
        margin-right: 5px;
    }
}
</style>
